import { render, staticRenderFns } from "./floor-amenity.vue?vue&type=template&id=3b931d3f"
import script from "./floor-amenity.vue?vue&type=script&lang=js"
export * from "./floor-amenity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports